import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import HubSectionCard from '../components/cards/HubSectionCard';
import hubs from '../cms/hubs.json';
import '../css/pages/StudentLife.css';

const StudentLife = () => {
  const hub = hubs.studentLife || {};
  const studentLifeSections = hub.cards || [];

  return (
    <>
      <PageHeader 
        title={hub.pageTitle} 
        subtitle={hub.pageSubtitle}
        showLogo={true}
      />
      
      <div className="student-life-container">
        <section className="student-life-sections">
          <div className="sections-grid">
            {studentLifeSections.map((section) => (
              <HubSectionCard key={section.path || section.externalUrl || section.title} card={section} />
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default StudentLife;
